import { trigger } from "./utility";

export function otherAutoselectClear(targetElem: HTMLElement) {
    let otherName = targetElem.dataset['gsTarget'];
    if (!otherName) {
        throw new Error("data-gs-target is needed for other-autoselect-clear")
    }
    let otherElems = document.getElementsByName(otherName);
    if (otherElems.length == 0) {
        throw new Error(`Can not find target element: ${otherName}`);
    } else if (otherElems.length > 1) {
        throw new Error(`more than one select element find: ${otherName}`);
    }
    let otherElem = otherElems[0] as HTMLInputElement;
    if (!(otherElem instanceof HTMLInputElement)) {
        throw new Error(`other-autoselect-clear only support text`);
    }
    if (!(targetElem instanceof HTMLInputElement)) {
        throw new Error(`other-autoselect-clear only support checkbox/radio`);
    }

    otherElem.addEventListener("input", function (e) {
        if (otherElem.value && !targetElem.checked) {
            targetElem.checked = true;
            trigger(targetElem, 'change');
        }
    });

    targetElem.addEventListener("change", function () {
        if (!targetElem.checked) {
            otherElem.value = '';
        }
    })
}